"use client";

import { useEffect } from "react";

const UTM_PARAMS = [
  "utm_campaign",
  "utm_source",
  "utm_medium",
  "utm_content",
  "utm_term",
] as const;

const STORAGE_KEY = "landing_utm";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Only process if we haven't already captured UTMs this session
    if (typeof window === "undefined" || sessionStorage.getItem(STORAGE_KEY)) {
      return;
    }

    // Parse URL search params directly from window.location
    const urlParams = new URLSearchParams(window.location.search);

    // Check if any UTM parameters exist
    const utmData: Record<string, string> = {};
    let hasUtms = false;

    UTM_PARAMS.forEach((param) => {
      const value = urlParams.get(param);
      if (value) {
        utmData[param] = value;
        hasUtms = true;
      }
    });

    // Only store and fire event if UTMs were found
    if (hasUtms) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utmData));

        // Fire campaign landing event if gtag is available
        if (window.gtag) {
          window.gtag("event", "campaign_landing", utmData);
        }
      } catch (error) {
        // Silently fail if sessionStorage is not available
        console.error("Failed to store UTM parameters:", error);
      }
    }
  }, []); // Empty deps - only run once on mount

  return <>{children}</>;
}